import { CHANNELTYPE } from "../../services/data";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface IProvider {
  id: number
  title: string
  status: number
}

export interface IBrandConfigsSMS {
  categoryCarIds: number[]
  brandName: string
  messageType: string
  phoneNumber: string
  unitIds: number[]
}

export interface IBrandConfigsZNS {
  id: number
  brandId: number
  brandName: string
  smtpPassword: string
  smtpUsername: string
  categories: string
  units: string
  connectDate: string
  status: number
}

//Danh sách nhà cung cấp
export const getListSmsProvider = async () => {
  const path = "integrationProviders/listSmsProvider"
  const params = {

  }
  const result: ResponseSuccessTotal<IProvider[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListZnsProvider = async () => {
  const path = "/integrationProviders/listZnsProvider"
  const params = {

  }
  const result: ResponseSuccessTotal<IBrandConfigsZNS[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



export const getInfoZnsProvider = async (id: number) => {
  const path = "/integrationProviders/infoZnsProvider"
  const params = {
    id
  }
  const result: ResponseSuccess<IBrandConfigsZNS> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin cấu hình nhà cung cấp
export const getInfoProvider = async (id: number) => {
  const path = "/integrationProviders/infoProvider"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IProvider[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};



//	Cập nhật trạng thái thành công
export const activeProvider = async (id: number) => {
  const path = "/integrationProviders/activeProvider"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IProvider[]> = await axiosClient.put(
    path, params
  );
  return result;
};

//Tạo  nhà cung cấp  SMS
export const addSmsConfig = async (
  providerId: number, apiEndpointCSKH: string, apiEndpointQC: string, username: string, password: string,
  brandConfigs: IBrandConfigsSMS[]
) => {
  const path = "/integrationProviders/addSmsConfig"
  const params = {
    providerId, apiEndpointCSKH, apiEndpointQC, username, password,
    brandConfigs
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};

export const addZnsProvider = async (
  zaloAppId: string, zaloAppSecret: string, zaloAppName: number, apiEndpoint: number
) => {
  const url = `/integrationProviders/addZnsProvider`;
  const params = {
    zaloAppId, zaloAppSecret, zaloAppName, apiEndpoint
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}



export const editZnsProvider = async (
  id: number, zaloAppId: string, zaloAppSecret: string, zaloAppName: number,
  apiEndpoint: number
) => {
  const url = `/integrationProviders/editZnsProvider`;
  const params = {
    id, zaloAppId, zaloAppSecret, zaloAppName,
    apiEndpoint
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

//	Cập nhật trạng thái thành công
export const deleteProvider = async (id: number) => {
  const path = "/integrationProviders/deleteProvider"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IProvider[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};



//#region  cấu hình zns
export const checkDuplicateZns = async (
  zaloOASecretKey: string, zaloRefreshToken: string,
  id?: number
) => {
  const url = `/integrationProviders/checkDuplicate`;
  const params = {
    zaloOASecretKey, zaloRefreshToken,
    id
  }
  const result: ResponseSuccess<{
    duplicateOASecretKey: boolean,
    duplicateRefreshToken: boolean
  }> = await axiosClient.post(
    url, params
  );
  return result;
}

export const getListZnsConfig = async (
  limit?: number, pageNumber?: number
) => {
  const path = "/integrationProviders/listZnsConfig"
  const params = {
    limit, pageNumber
  }
  const result: ResponseSuccessTotal<IBrandConfigsZNS[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//	Thông tin cấu hình Zns
export const getInfoZnsConfig = async (id: number) => {
  const path = "/integrationProviders/infoZnsConfig"
  const params = {
    id
  }
  const result: ResponseSuccess<IZnsConfig> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const activeConfig = async (
  id: number
) => {
  const url = `/integrationProviders/activeConfig`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

export const addZnsConfig = async (
  brandName: string, unitIds: number[], categoryCarIds: number[], username: string,
  password: string,
) => {
  const url = `/integrationProviders/addZnsConfig`;
  const params = {
    brandName, unitIds, categoryCarIds, username, password
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

export interface IZnsConfig {
  id: number
  brandId: number
  brandName: string
  channelType: number
  username: string
  password: string
  categoryCarIds: number[]
  unitIds: number[]
}





export const editZnsConfig = async (
  id: number, brandName: string, unitIds: number[], categoryCarIds: number[],
  username: string,
  password: string,
) => {
  const url = `/integrationProviders/editZnsConfig`;
  const params = {
    id, brandName, unitIds, categoryCarIds, username, password
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}


//#endregion


